import { render, staticRenderFns } from "./etapa_3.vue?vue&type=template&id=76780ee0&scoped=true&"
import script from "./etapa_3.vue?vue&type=script&lang=js&"
export * from "./etapa_3.vue?vue&type=script&lang=js&"
import style0 from "./etapa_3.vue?vue&type=style&index=0&id=76780ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76780ee0",
  null
  
)

export default component.exports